import { render, staticRenderFns } from "./EnterApp.vue?vue&type=template&id=2f2b7c1c&scoped=true";
import script from "./EnterApp.vue?vue&type=script&lang=js";
export * from "./EnterApp.vue?vue&type=script&lang=js";
import style0 from "./EnterApp.vue?vue&type=style&index=0&id=2f2b7c1c&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "2f2b7c1c", null);
export default component.exports;